export default function Accueil() {
    return (
        <div className="Accueil">
            <h2>Magasin</h2>
            <p>Page d'accueil en contrsuction</p>
        </div>
    );
}